// extracted by mini-css-extract-plugin
export default {"root":"PlasmicSearchRectangle_root__ONu62","roottestVariant":"PlasmicSearchRectangle_roottestVariant__E3l-Z"};